<template>
  <c-modal
    class="c-blogPostPopup"
    title="投稿したブログが公開されました"
    :width="560"
    :active="isVisible"
    @close="$emit('close')"
  >
    <div>
      <img
        v-if="isFirstOpen"
        src="@/assets/images/pages/blogs/new-open-sns-pc.png"
        alt="おめでとうございます！"
      >
      <div
        class="c-blogPostPopup_existingOpen"
        v-else
      >
        あなたが投稿したブログが公開されました。<br>
        SNSでシェアして、みんなに広めましょう。
      </div>
    </div>
    <div slot="footer">
      <div class="c-shareLinksWrap">
        <social-sharing
          class="c-shareLinks"
          :url="facebookUrl"
          :title="title"
          :hashtags="hashtags"
          :is-monochromatic="false"
          inline-template
        >
          <network network="facebook">
            <c-button-v2
              class="c-shareLinks_facebookBtn"
              width="228px"
              icon-name="facebook-brands"
              icon-size="20px"
              size="m"
              @click="$emit('close')"
            >シェアする</c-button-v2>
          </network>
        </social-sharing>
        <social-sharing
          class="c-shareLinks"
          :url="twitterUrl"
          :title="title"
          :hashtags="hashtags"
          :is-monochromatic="false"
          inline-template
        >
          <network network="twitter">
            <c-button-v2
              class="c-shareLinks_twitterBtn"
              width="228px"
              icon-name="twitter-circle"
              icon-size="20px"
              size="m"
              @click="$emit('close')"
            >ツイートする</c-button-v2>
          </network>
        </social-sharing>
      </div>
    </div>
  </c-modal>
</template>
<script>
export default {
  name: 'BlogPostPopup',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    path: {
      type: String
    },
    title: {
      type: String
    },
    isFirstOpen: {
      type: Boolean,
      default: false
    },
    hashtags: {
      type: String,
      default: ''
    }
  },
  computed: {
    utmCampaign() {
      return this.isFirstOpen ? 'b_opn' : 'b_edt'
    },
    twitterUrl() {
      return `${this.getUrl()}?utm_medium=social&utm_campaign=${
        this.utmCampaign
      }&utm_content=pc&utm_source=twitter`
    },
    facebookUrl() {
      return `${this.getUrl()}?utm_medium=social&utm_campaign=${
        this.utmCampaign
      }&utm_content=pc&utm_source=facebook`
    }
  },
  methods: {
    getUrl() {
      return this.path ? `${location.origin}${this.path}` : location.href
    }
  }
}
</script>

<style lang="scss" scoped>
.c-blogPostPopup {
  /deep/ .c-modal {
    &_body {
      padding-top: 0;
    }

    &_footer {
      text-align: center;
      padding-bottom: 40px;
    }
  }

  &_existingOpen {
    font-size: 14px;
    padding: 40px 24px 0;
    text-align: center;
  }
}

.c-shareLinksWrap {
  display: flex;
  justify-content: center;
}

/deep/ .c-shareLinks {
  &_facebookBtn {
    background: $color-sns-facebook;
    border: 0;
    color: $color-white;
    margin-right: 24px;
  }

  &_twitterBtn {
    background: $color-sns-twitter;
    border: 0;
    color: $color-white;
  }
}
</style>
